import React, {useState} from 'react';
import {Translate} from "../../../lang/lang";
import {useDispatch, useSelector} from "react-redux";
import {selectLang} from "../../../store/reducers/main/main";
import {
    loadItemsAsync,
    updateCategories,
    updateCategoriesTree,
    updateItems, updateItemsDictionary
} from "../../../store/reducers/item/itemReducer";
import IconButton from "../../IconButton";
import {Spinner} from "react-bootstrap";
import {faRefresh} from "@fortawesome/free-solid-svg-icons";

const ReloadItems = () => {
    const t = Translate;
    const lang = useSelector(selectLang);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const onReloadDatatable = () => {
        setLoading(true);
        loadItemsAsync()
            .then(({categories, categoriesTree, data}) => {
                dispatch(updateItems(data));
                dispatch(updateItemsDictionary(data));
                dispatch(updateCategories(categories));
                dispatch(updateCategoriesTree(categoriesTree));
                setLoading(false);
            })
            .catch((error) => {
                dispatch(updateItems([]));
                dispatch(updateItemsDictionary([]));
                dispatch(updateCategories([]));
                dispatch(updateCategoriesTree([]));
                setLoading(false);
            })
    }

    return (
        <IconButton icon={faRefresh}
                    variant={'falcon-warning'}
                    size={'sm'}
                    className="btn-davr px-2  py-0 bg-white text-dark gap-2"
                    iconClassName={'text-primary-davr'}
                    onClick={onReloadDatatable}
                    disabled={loading}
        >
            {t(lang, 'items.common.reload')}
            {loading && <Spinner className='align-middle ms-2' animation='border' role='switch' size='sm'/>}
        </IconButton>
    );
};

export default ReloadItems;
